<template>
  <div>
    <a-upload-dragger class="file-uploader" :file-list="fileList" :show-upload-list="false"
      :before-upload="beforeUpload" @change="handleChange" @remove="handleRemove" list-type="picture" :max-count="1">
      <div>
        <i class="fa-solid fa-cloud-arrow-up fa-3x mb-3"></i>

        <!-- preview -->
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />

        <div class="upload-text">
          {{ $t('upload.clickUpload') }}
        </div>
      </div>
    </a-upload-dragger>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { uploadFileOne, apiPost } from "@/api/index";
import { SAVE_FILE_ONE } from "@/api/const/file";
const emits = defineEmits(["uploadOneSuccess"]);
import { message } from 'ant-design-vue';

const fileList = ref<any[]>([]);
const imageUrl = ref("");

interface Props {
  documentClass: any,
  ocr: any,
  fileDraft: any,
}

const props = withDefaults(defineProps<Props>(), {
  documentClass: "INVOICE",
  ocr: "Y",
  fileDraft: "N"
})
const beforeUpload = () => {
  // chặn auto upload của antd
  return false;
};

// const uploadFile = async (file: File) => {
//   if (!file) return;

//   // preview
//   imageUrl.value = URL.createObjectURL(file);

//   const formData = new FormData();
//   formData.append("documents", file);
//   formData.append("ocr", props.ocr);
//   formData.append("fileDraft", props.fileDraft);
//   formData.append("documentClass", props.documentClass);

//   try {
//     const response = await uploadFileOne(formData) || {};
//     let value = response.data?.data || "";
//     let url = value.fileUrl + value.folderPath + value.fileName || "";
//     let data = await saveFile(value);
//     if(data) {
//        emits("uploadOneSuccess", url);
//     }

//   } catch (e) {
//     console.error("upload error", e);
//   }
// };

const uploadFile = async (file: File) => {
  if (!file) return;

  // preview file mới
  imageUrl.value = URL.createObjectURL(file);

  const formData = new FormData();
  formData.append("documents", file);
  formData.append("ocr", props.ocr);
  formData.append("fileDraft", props.fileDraft);
  formData.append("documentClass", props.documentClass);

  try {
    const response = await uploadFileOne(formData);

    const value = response?.data?.data;

    if (!value) return;

    const url = `${value.fileUrl}${value.folderPath}${value.fileName}`;

    const data = await saveFile(value);

    if (data) {
      emits("uploadOneSuccess", url);

      // giữ lại đúng 1 file
      fileList.value = [
        {
          uid: file.uid || Date.now(),
          name: file.name,
          status: "done",
          url,
        },
      ];
    }
  } catch (e) {
    console.error("upload error", e);

    fileList.value = [];
  }
};

const saveFile = async (info: any) => {
  let data = await apiPost(SAVE_FILE_ONE, info);
  message.success('Tải lên file thành công');
  return data.data;
}

const handleChange = async (info: any) => {
  // chỉ lấy file mới nhất
  const latestFile = info.fileList.slice(-1);

  fileList.value = latestFile;

  // lấy file thật
  const file = latestFile?.[0]?.originFileObj;

  if (!file) return;

  // clear preview cũ tránh memory leak
  if (imageUrl.value) {
    URL.revokeObjectURL(imageUrl.value);
  }

  await uploadFile(file);
};

const handleRemove = () => {
  fileList.value = [];

  if (imageUrl.value) {
    URL.revokeObjectURL(imageUrl.value);
  }

  imageUrl.value = "";
};
</script>

<style scoped>
.file-uploader {
  width: 100%;
}

.avatar {
  width: 100%;
  margin-top: 10px;
  border-radius: 8px;
}

.upload-text {
  margin-top: 10px;
}
</style>

<style>
.file-uploader .ant-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s;
}

.file-uploader .ant-upload:hover {
  border-color: #1677ff;
}
</style>